import axios from 'axios';

class QuickShareApi {
  hasPending() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/quick-share/has-pending')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }

  receivePending() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/quick-share/receive-pending')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
}

const api = new QuickShareApi();
export default api;
